import React from "react";
import useScrollReveal from "@/hooks/useScrollReveal";

import CategoryHero from "@/components/site/CategoryHero";
import CategoryTabs from "@/components/site/CategoryTabs";
import ProcessMain from "@/components/site/main/ProcessMain";
import ProjectCatalogue from "@/components/site/ProjectCatalogue";
import WhatWeOfferMain from "@/components/site/main/WhatWeOfferMain";
import TrustedPartners from "@/components/site/TrustedPartners";
import LaunchOfferMain from "@/components/site/main/LaunchOfferMain";
import FAQ, { MAIN_FAQS } from "@/components/site/FAQ";
import PreFooterCTAMain from "@/components/site/main/PreFooterCTAMain";
import SEO from "@/components/site/SEO";
import { pageSeo, localBusinessJsonLd, serviceJsonLd, faqJsonLd } from "@/lib/seo-config";

export default function RestaurantInteriorsDubai() {
    useScrollReveal();
    return (
        <main data-testid="page-restaurant-interiors">
            <SEO
                {...pageSeo.restaurant}
                jsonLd={[
                    localBusinessJsonLd,
                    serviceJsonLd({
                        type: "Restaurant Interiors",
                        name: "Restaurant Interiors Dubai",
                        description: pageSeo.restaurant.description,
                        path: pageSeo.restaurant.path,
                    }),
                    faqJsonLd(MAIN_FAQS),
                ]}
            />
            <CategoryHero
                eyebrow="RESTAURANT • CAFÉ • DUBAI"
                h1="Restaurant &amp; Café Interiors in Dubai"
                sub="Seating layouts, mood lighting, counters, finishes, branding and handover support for restaurants and cafés across Dubai — designed to be launch-ready in 45 days."
                image="https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&w=1400&q=85"
                imageAlt="Dubai restaurant interior with warm mood lighting, dining seating layout and branded counter"
                estimatorType="restaurant"
            />
            <CategoryTabs initialTab="restaurant" />
            <ProcessMain />
            <ProjectCatalogue />
            <WhatWeOfferMain />
            <TrustedPartners />
            <LaunchOfferMain />
            <FAQ items={MAIN_FAQS} />
            <PreFooterCTAMain />
        </main>
    );
}
